<div class="visitor-scan-qrcode">
  <sc-flex [vertical]="true" [centered]="true">
    <h2>Halten Sie Ihren QRCode vor die Kamera. Der Scan erfolgt automatisch.</h2>
    <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
    <div class="cam">
      <zxing-scanner #scanner [enable]="scannerEnabled"
                    [device]="deviceCurrent"
                    (camerasFound)="camerasFoundHandler($event)"
                    (scanSuccess)="scanSuccessHandler($event)"
                    (scanError)="scanErrorHandler($event)"
                    (scanComplete)="scanCompleteHandler($event)"></zxing-scanner>
    </div>
    <div>
      {{errorMessageDictionaryKey | translate: [errorMessageDictionaryKey, translationService.language]}}
    </div>
  </sc-flex>
</div>
